import { CONSOLE_PALETTE, CONSOLE_PANEL_SKIN } from '../theme';
import { cn } from '@/lib/utils';

export const CLASSES_PALETTE = cn(
  CONSOLE_PALETTE,
  '[&_.lbl]:text-slate-700 dark:[&_.lbl]:text-slate-200 [&_.lbl]:text-sm [&_.lbl]:font-bold',
  '[&_label]:text-slate-700 dark:[&_label]:text-slate-200 [&_label]:text-sm [&_label]:font-bold',
  '[&_legend]:text-slate-700 dark:[&_legend]:text-slate-200 [&_legend]:text-sm [&_legend]:font-bold',
);

export const CLASSES_PANEL_SKIN = cn(
  CONSOLE_PANEL_SKIN,
  '[&_section.card]:rounded-3xl [&_section.card]:bg-white dark:[&_section.card]:bg-[#111c2e] [&_section.card]:[background-image:none] [&_section.card]:border-slate-200/90 dark:[&_section.card]:border-slate-800',
  '[&_section.card>header]:rounded-t-3xl [&_section.card>header]:bg-slate-100 dark:[&_section.card>header]:bg-[#0b1322] [&_section.card>header]:border-b [&_section.card>header]:border-slate-200 dark:[&_section.card>header]:border-slate-800',
  '[&_.lbl]:text-slate-700 dark:[&_.lbl]:text-slate-200 [&_.lbl]:text-sm [&_.lbl]:font-bold',
  '[&_label]:text-slate-700 dark:[&_label]:text-slate-200 [&_label]:text-sm [&_label]:font-bold',
  '[&_legend]:text-slate-700 dark:[&_legend]:text-slate-200 [&_legend]:text-sm [&_legend]:font-bold',
);
